import * as TruckService from '../services/truck-service';

export function resetTruckState(state) {
  return function (dispatch) {
    dispatch(reset(state));
  };
}

export function fetchTrucks() {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await TruckService.getTrucks();
      dispatch(success('FETCH_TRUCKS', response.data));
    } catch(err) {
      dispatch(error('TRUCK_ERROR', err));
    }
  };
}

export function saveTruck(truck) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await TruckService.save(truck);
      return dispatch(success('ADD_TRUCK', response.data));
    } catch (err) {
      return dispatch(error('TRUCK_ERROR', err));
    }
  };
}

export function updateTruck(truckId, truck) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await TruckService.update(truckId, truck);
      return dispatch(success('UPDATE_TRUCK', response.data));
    } catch (err) {
      return dispatch(error('TRUCK_ERROR', err));
    }
  };
}

/* Search Trucks */
export function searchTruck(searchParameters) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await TruckService.search(searchParameters);
      dispatch(success('SEARCH_TRUCKS', response.data));
    } catch(err) {
      dispatch(error('TRUCK_ERROR', err));
    }
  };
}

function reset(type) {
  return {
    type: type,
  };
}

function process() {
  return {
    type: 'PROCESSING_TRUCK',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}

function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}